import React, { useEffect } from 'react';
// store
import { useDispatch, useSelector } from 'react-redux';
import { uploadPhoto } from '../../store/modules/gifts';
import { getDeal, updateDeal, getCountries } from '../../store/modules/deals';
// components
import { DealsDetailsForm } from './DealsDetailsForm';
// styles
import styles from './DealsDetails.module.css';

export const DealsDetailsPage = ({ match, history }) => {
  const dispatch = useDispatch();
  const deal = useSelector((state) => state.deals.details);
  const countries = useSelector((state) => state.deals.countries);

  const onUpdateDeal = ({ photo, photoPreview, ...values }) => {
    const expirationDate = values.expirationDate || '2050-01-01T10:00:00.000+03:00';

    if (!photo || photo?.path) {
      dispatch(updateDeal(values.id, { ...values, expirationDate })).then(() => history.goBack());
      return;
    }

    const formData = new FormData();
    const file = new File([photo], 'image.jpeg');

    formData.append('file', file);

    dispatch(uploadPhoto(formData)).then((response) => {
      dispatch(
        updateDeal(values.id, {
          ...values,
          photo: response.value,
          expirationDate,
        }),
      ).then(() => history.goBack());
    });
  };

  useEffect(() => {
    dispatch(getDeal(match.params.id));
  }, [dispatch, match]);

  useEffect(() => {
    dispatch(getCountries());
  }, [dispatch]);

  if (!deal) {
    return null;
  }

  return (
    <div>
      <h1 className={styles.title}>Deal</h1>

      <DealsDetailsForm onSubmit={onUpdateDeal} values={deal} countries={countries} />
    </div>
  );
};
